/// Single radar theme for the web MVP. We port the iOS "modern" palette
/// from FlatoutATC/Support/RadarTheme.swift — easiest on the eye and
/// works equally well in light/dark browser chrome. Multi-theme support
/// is a Phase 2 nicety.

export const radarTheme = {
  background: 0x0d101a,
  land: 0x29384d,
  landStroke: 0x5271a0,
  river: 0x1f4a78,
  runway: 0xe6e6e6,
  centerline: 0xffffff,
  airportMarker: 0xbdd7ff,
  fix: 0x8ff2f2,
  vor: 0xeb8cf9,
  track: 0xa9d2ff,
  label: 0x808093,
  // Bright magenta — outside the contour palette's earth tones
  // (greens/yellows/oranges/reds) so a selected aircraft pops on any
  // terrain. The warm-gold #ffd65a we used before sat inside the
  // 3k–7k hypsometric bands (0xe6bf4d / 0xffa633), making a selected
  // aircraft disappear over the Himalayas (Lukla) and Alps
  // (Innsbruck). Paired with the selection ring drawn by the aircraft
  // layer for double-pop on dense maps.
  selected: 0xff4dd9,
  vector: 0x6ea3d4,
  alert: 0xff4d4d,
  /// Aircraft-aircraft conflict (proximity to another aircraft).
  conflict: 0xfacc15,
  /// Terrain proximity (within 2 NM and 300 ft of a polygon).
  terrainWarning: 0xff8c42,
  /// Thunderstorm phases (matches iOS GameScene.swift:2760-2772).
  /// Forming = yellow (low intensity), mature = red (peak danger),
  /// dissipating = orange (waning).
  weatherForming: 0xfacc15,
  weatherMature: 0xef4444,
  weatherDissipating: 0xfb923c,
} as const

/// 0xRRGGBB → CSS-friendly hex string for chrome use.
export function hexCss(c: number): string {
  return '#' + c.toString(16).padStart(6, '0')
}
